module.exports = __webpack_public_path__ + "img/平板.fbaaad1a.png";